<!--eslint-disable-->
<template>
    <el-container>
        <el-main class="main">
            <div id="distributor-content">
                <el-dialog title="Adicionar Distribuidor" :visible.sync="dialogDistributorVisible">
                    <el-form :model="xmlNewClient">
                        <el-form-item label="CNPJ Distribuidor">
                            <el-input v-model="xmlNewClient.CNPJDistribuidor"></el-input>
                        </el-form-item>
                        <el-form-item label="Nome">
                            <el-input v-model="xmlNewClient.nome"></el-input>
                        </el-form-item>
                        <el-form-item label="Id Pessoa Distribuidor">
                            <el-input v-model="xmlNewClient.idPessoaDistribuidor"></el-input>
                        </el-form-item>
                        <el-form-item label="Emails distribuidor">
                            <el-input v-model="xmlNewClient.email"></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="cancelarAdicionarDistribuidor">Cancelar</el-button>
                        <el-button type="primary" @click="adicionarDistribuidor">Adicionar</el-button>
                    </span>
                </el-dialog>
                <el-dialog :visible.sync="dialogMovFileVisible">
                    <template slot="title">
                        <span class="main-title"> {{ movFile.name }} </span>
                    </template>
                    <div class="big-content">
                        <table>
                            <tr v-for="row in movFile.content">
                                <td v-for="element in row"> {{ element }} </td>
                            </tr>
                        </table>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogMovFileVisible = false">Fechar</el-button>
                        <el-button type="primary" @click="copyToClipboard(movFile.content)">Copiar</el-button>
                    </span>
                </el-dialog>
                <el-dialog title="Template de email para distribuidoras" :visible.sync="dialogEmailDistributorsVisible">
                    <el-form :model="emailTemplate">
                        <el-form-item label="Destinatários além do email cadastrado da distribuidora (separados por ;)">
                            <el-input v-model="emailTemplate.recipients"></el-input>
                        </el-form-item>
                        <el-form-item label="Corpo do email">
                            <el-input type="textarea" v-model="emailTemplate.content"></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogEmailDistributorsVisible = false">Cancelar</el-button>
                        <el-button type="primary" @click="updateDistributorsEmailTemplate">Salvar</el-button>
                    </span>
                </el-dialog>
                <div class="header-manual">
                    <span>Distribuidoras Cadastrados</span>
                    <el-button @click="showDistributorForm" type="primary" style="margin-left: 10px">Adicionar Distribuidor</el-button>
                    <span style="margin-left: 40px">Data de referência: </span>
                    <el-date-picker class="date-picker" v-model="chosenDate" type="date" format="dd/MM/yyyy" @change="updateFilesForRefDate"></el-date-picker>
                </div>
                <div id="distributor-content-column-1">
                    <div id="table-distribuidors">
                        <el-table
                            v-loading="loadingDistributor"
                            :data="tableDistribuidor"
                            border
                            size="mini"
                            class="distributor"
                            stripe>
                            <el-table-column
                                prop="distribuidorChecked"
                                width="35">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.distribuidorCheckbox.status" :disabled="scope.row.distribuidorCheckbox.disabled"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="CNPJDistribuidor"
                                label="CNPJ Distribuidor"
                                width="150">
                                <template slot-scope="scope">
                                    <span @click="distribuidorCnpjClicked(scope)"> {{ scope.row[scope.column.property] }} </span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                sortable
                                prop="nome"
                                label="Nome"
                                width="266">
                                <template slot-scope="scope">
                                    <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarDistribuidor"></NewEditableColumn>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="idPessoaDistribuidor"
                                label="Id Pessoa Distribuidor"
                                width="148">
                                <template slot-scope="scope">
                                    <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarDistribuidor"></NewEditableColumn>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="email"
                                label="Emails distribuidor"
                                width="300">
                                <template slot-scope="scope">
                                    <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarDistribuidor"></NewEditableColumn>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="delete"
                                label="Nome"
                                width="70"> 
                                <template slot-scope="scope">
                                    <div class="header-details">
                                        <span @click="removerDistribuidor(scope)"><i class="el-icon-delete"></i></span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div id="distributor-content-column-2">
                    <div class="header-manual distributor-content-column-2-item">
                        <span id="upload-movimentacao-administradora-mensagem">Upload arquivo de movimentações da administradora:</span>
                    </div>
                    <el-upload
                        id="upload-movimentacao-administradora-dropbox"
                        class="upload-demo distributor-content-column-2-item"
                        drag
                        action=""
                        :http-request="onHttpRequestDistribuidorMovFile"
                        :on-remove="handleRemoveDistribuidorMovFile" 
                        :on-preview="handlePreviewDistribuidorMovFile"
                        :file-list="fileListRetornoMovimentacoes"
                        :limit="1"
                        :on-exceed="multipleMovFilesUploaded"
                        multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Arraste aqui ou <em>clique para upload</em></div>
                    </el-upload>
                    <template v-if="showMultipleMovFilesUploadedAlert">
                        <el-alert
                            title="Apenas um arquivo de movimentações da administradora pode ser usado por vez.
                            Para usar um novo arquivo primeiro exclua o anterior."
                            type="error">
                        </el-alert>
                    </template>
                    <el-button type="primary" icon="el-icon-message" id="button-send-email-administrador" 
                        class="distributor-content-column-2-item" @click="sendEmailToDistributorsConfirm">Enviar email de movimentações</el-button>
                    <br>
                    <el-button type="primary" icon="el-icon-edit" class="distributor-content-column-2-item"
                        @click="showDialogEmailDistributors">Editar email template</el-button>
                </div>
                <br style="clear:both"/>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase/app'
import fb from '@/services/firebaseConfig'
import NewEditableColumn from '@/components/NewEditableColumn.vue'
import format from 'xml-formatter'
import regex from '@/services/regex'

const db = fb.db

function maybeRemoveFirstZero(cnpj) {
    if (cnpj.charAt(0) == '0') {
        return cnpj.substr(1)
    }
    return cnpj
}

export default {
    data() {
        return {
            loading: true,
            loadingDistributor: false,
            refDate: null,
            chosenDate: new Date(),
            table: null,
            dialogVisible: false,
            dialogDistributorVisible: false,
            dialogMovFileVisible: false,
            dialogEmailDistributorsVisible: false,
            xmlNewClient: {
                CNPJDistribuidor: '',
                nome: '',
                idPessoaDistribuidor: 0,
                email: ''
            },
            movFile: {
                name: '',
                content: []
            },
            emailTemplate: {
                recipients: '',
                content: '',
                firebaseDocId: ''
            },
            distribuidorTable: [],
            movFilesTable: [],
            file: Object,
            fileListRetornoMovimentacoes: [],
            showMultipleMovFilesUploadedAlert: false
        }
    },
    components: {
        NewEditableColumn
    },
    methods: {
        showDialogEmailDistributors() {
            db.collection('emailDistributorsTemplate')
                .get()
                .then(
                    q => {
                        q.forEach(doc => {
                            this.emailTemplate = {
                                recipients: doc.data().recipients,
                                content: doc.data().content,
                                firebaseDocId: doc.id
                            }
                        })
                    }
                )
            this.dialogEmailDistributorsVisible = true
        },
        async updateFilesForRefDate() {
            db.collection('distAttachments')
                .where('timestamp', '<=', this.fimDia())
                .where('timestamp', '>=', this.inicioDia())
                .orderBy('timestamp', 'desc')
                .onSnapshot(
                    q => {
                        let auxTable = []
                        let date;
                        q.forEach(doc => {
                            date = doc.data().timestamp
                            auxTable.push({
                                status: false,
                                timestamp: new Date(doc.data().timestamp.seconds * 1000).toLocaleDateString("pt-BR"),
                                subject: doc.data().subject,
                                sender: doc.data().sender,
                                attachment_name: doc.data().attachment_name,
                                attachment: doc.data().attachment,
                                id: doc.id
                            })
                        })
                        this.table = auxTable
                        this.refDate = date
                        this.chosenDate = new Date(date.seconds * 1000)
                })
                
            db.collection('movFiles')
                .where('clientXML.timestamp', '<=', this.fimDia())
                .where('clientXML.timestamp', '>=', this.inicioDia())
                .orderBy('clientXML.timestamp', 'desc')
                .onSnapshot(
                    q => {
                        let auxTable = []
                        q.forEach(doc => {
                            
                            let retornoXML = doc.data().retornoXML
                            let readyMovCsv = doc.data().readyMovCSV
                            
                            auxTable.push({
                                data: new Date(doc.data().clientXML.timestamp.seconds * 1000).toLocaleString("pt-BR"),
                                retorno: !!retornoXML ? "OK" : "",
                                id: doc.id,
                                readyMovCSV: !!readyMovCsv ? true : false
                            })
                        })
                        this.movFilesTable = auxTable
                })
                
            await this.updateReturnMovFilesFromDb()
        },
        showDialog() {
            this.dialogVisible = true
        },
        showDistributorForm() {
            this.dialogDistributorVisible = true;
        },
        async onHttpRequestDistribuidorMovFile(file, fileList) {
            let fileReader = new FileReader()
            fileReader.onload = async function (fileName, event) {
                let text = event.target.result
                let textParsedLines = text.split("\n")
                let textAsArray = textParsedLines.map((line) => {
                    return line.split("\t")
                })

                // Habilitar e marcar checkboxes das distribuidoras com movimentação
                this.updateCheckboxesDistribuidoras(textAsArray)
                
                // Salvar no banco e alterar interface com arquivo carregado
                let saveRetornoMovimentacoes = firebase.functions().httpsCallable('saveRetornoMovimentacoes');
                try {
                    let result = await saveRetornoMovimentacoes({refDate: this.chosenDate.getTime(), fileName: fileName, content: text})
                    let filePathSegments = result.data.result._path.segments
                    let fileIdFirebase = filePathSegments[filePathSegments.length - 1] // id do elemento no firebase é o último segmento do path
                    this.fileListRetornoMovimentacoes.push({fileData: textAsArray, name: fileName, storageFile: false, fileIdFirebase})
                } catch (err) {
                    this.$root.$emit('showError', err, 'error')
                }
            }.bind(this, file.file.name)
            fileReader.readAsText(file.file, 'ISO-8859-1')
        },
        async handleRemoveDistribuidorMovFile(file, fileListRetornoMovimentacoes) {
            this.fileListRetornoMovimentacoes = fileListRetornoMovimentacoes
            this.tableDistribuidor.map((distribuidorCadastrado) => {
                distribuidorCadastrado["distribuidorCheckbox"] = {
                    status: false,
                    disabled: true
                }
            })
            let deleteRetornoMovimentacoes = firebase.functions().httpsCallable('deleteRetornoMovimentacoes');
            try {
                let result = await deleteRetornoMovimentacoes({fileId: file.fileIdFirebase})
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        async handlePreviewDistribuidorMovFile(file) {
            this.movFile.content = file.fileData
            this.movFile.name = file.name
            this.dialogMovFileVisible = true
        },
        async getXmlNewClientTemplate() {
            let getTemplate = firebase.functions().httpsCallable('getXmlNewClientTemplate')
            try {
                var template = await getTemplate()
                return template
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        async removerDistribuidor(scope) {
            this.loadingDistributor = true
            let removerDistribuidor = firebase.functions().httpsCallable('deleteXmlNewClientTemplate');
            try {
                let result = await removerDistribuidor({id: scope.row.id})
                this.$root.$emit('showError', result.data.result, 'success')
                this.loadingDistributor = false
            } catch (err) {
                this.$root.$emit('showError', "Erro. Entre em contato com o administrador do site.", 'error')
                this.loadingDistributor = false
            }
        },
        async alterarDistribuidor(value, scope) {
            let scopeRowObj = {
                CNPJDistribuidor: scope.row.CNPJDistribuidor,
                email: scope.row.email,
                nome: scope.row.nome,
                idPessoaDistribuidor: Number(scope.row.idPessoaDistribuidor),
                id: scope.row.id,
            }

            let alterarDistribuidor = firebase.functions().httpsCallable('updateXmlNewClientTemplate');
            try {
                let result = await alterarDistribuidor(scopeRowObj)
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        async adicionarDistribuidor() {
            let distributor = {
                CNPJDistribuidor: this.xmlNewClient.CNPJDistribuidor,
                nome: this.xmlNewClient.nome,
                idPessoaDistribuidor: Number(this.xmlNewClient.idPessoaDistribuidor),
                email: this.xmlNewClient.email,
            }
            
            let adicionarDistribuidor = firebase.functions().httpsCallable('addXmlNewClientTemplate')
            
            try {
                let result = await adicionarDistribuidor(distributor)
                this.dialogDistributorVisible = false
                
                this.xmlNewClient = {
                    CNPJDistribuidor: '',
                    nome: '',
                    idPessoaDistribuidor: 0,
                    email: ''
                }
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        cancelarAdicionarDistribuidor() {
            this.xmlNewClient = {
                CNPJDistribuidor: '',
                nome: '',
                idPessoaDistribuidor: 0,
                email: ''
            }
            this.dialogDistributorVisible = false
        },
        fimDia() {
            let now = new Date(this.chosenDate)
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
        },
        inicioDia() {
            let now = new Date(this.chosenDate)
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
        },
        copyToClipboard(textToCopy) {
            let textarea = document.createElement('textarea')
            textarea.value = textToCopy
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand('copy')
            document.body.removeChild(textarea)
        },
        multipleMovFilesUploaded() {
            this.showMultipleMovFilesUploadedAlert = true
        },
        async updateReturnMovFilesFromDb() {
            const inicioDiaRefDate = (new Date(this.chosenDate.setHours(0,0,0,0))).getTime()
            const finalDiaRefDate = (new Date(this.chosenDate.setHours(23,59,59,999))).getTime()
            let movReturnFiles = (await db.collection('movReturnFiles')
            .where('_refDate', '>=', inicioDiaRefDate)
            .where('_refDate', '<=', finalDiaRefDate)
            .get()).docs
            let fileListRetornoMovimentacoesAux = []
            movReturnFiles.forEach((doc) => {
                let name = doc.data().fileName
                let fileIdFirebase = doc.id
                let file = doc.data().content
                let textParsedLines = file.split("\n")
                let textAsArray = textParsedLines.map((line) => {
                    return line.split("\t")
                })
                fileListRetornoMovimentacoesAux.push({fileData: textAsArray, name, storageFile: false, fileIdFirebase})
            })
            this.fileListRetornoMovimentacoes = fileListRetornoMovimentacoesAux
            
            // Habilitar e marcar checkboxes das distribuidoras com movimentação
            let textAsArray = this.fileListRetornoMovimentacoes.length > 0 ? this.fileListRetornoMovimentacoes[0].fileData : []
            this.updateCheckboxesDistribuidoras(textAsArray)
        },
        distribuidorCnpjClicked(scope) {
            if (this.fileListRetornoMovimentacoes.length == 0) return
            let cnpjClicked = scope.row[scope.column.property]
            let movimentacoesAsArray = this.fileListRetornoMovimentacoes[0].fileData
            let movimentacoesHeader = movimentacoesAsArray[0]
            let movimentacoesFromCnpjClicked = movimentacoesAsArray.filter((line) => line[31] == cnpjClicked)
            if (movimentacoesFromCnpjClicked.length > 0) {
                this.movFile.content = [movimentacoesHeader, ...movimentacoesFromCnpjClicked]
                this.movFile.name = this.fileListRetornoMovimentacoes[0].name
                this.dialogMovFileVisible = true
            }
        },
        updateCheckboxesDistribuidoras(textAsArray) {
            let cnpjDistribuidorasComMov = textAsArray.map((line) => {
                return line[31] // coluna com header CPF_CNPJ_COTISTA
            })
            this.tableDistribuidor.map((distribuidorCadastrado) => {
                let cnpjDistribuidorCadastrado = distribuidorCadastrado["CNPJDistribuidor"]
                let cnpjDistribuidorCadastradoComMov = cnpjDistribuidorasComMov.filter((cnpjDistribuidorComMov) => {
                    return cnpjDistribuidorComMov == cnpjDistribuidorCadastrado
                })
                if(cnpjDistribuidorCadastradoComMov.length > 0) {
                    // Existe uma movimentação desse distribuidor no arquivo, devo habilitar e marcar a checkbox
                    distribuidorCadastrado["distribuidorCheckbox"] = {
                        status: true,
                        disabled: false
                    }
                } else {
                    distribuidorCadastrado["distribuidorCheckbox"] = {
                        status: false,
                        disabled: true
                    }
                }
            })
        },
        async updateDistributorsEmailTemplate() {
            let emailTemplate = {
                recipients: this.emailTemplate.recipients,
                content: this.emailTemplate.content,
                docId: this.emailTemplate.firebaseDocId
            }
            
            let updateEmailTemplateInFirebase = firebase.functions().httpsCallable('updateDistributorsEmailTemplate')
            
            try {
                let result = await updateEmailTemplateInFirebase(emailTemplate)
                 this.dialogEmailDistributorsVisible = false
                this.$root.$emit('showError', result.data.result, 'success')
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
        },
        async sendEmailToDistributorsConfirm() {
            this.$confirm('Você tem certeza que quer mandar emails para as distribuidoras selecionadas?', {
                confirmButtonText: 'Enviar emails',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(async () => {
                await this.sendEmailToDistributors()
                this.$message({
                    type: 'success',
                    message: 'Emails enviados'
                })
            }).catch((err) => {
                this.$message({
                    type: 'info',
                    message: 'Operação cancelada'
                });          
            });
        },
        async sendEmailToDistributors() {
            let selectedDistribuitors = this.tableDistribuidor.filter(distribuidorCadastrado => distribuidorCadastrado["distribuidorCheckbox"].status)
            await Promise.all(selectedDistribuitors.map(async (distributor) => {
                let recipients = [...this.emailTemplate.recipients.split(';'), distributor.email]
                let subject = `${distributor.nome} Movimentações - Leblon Equities`
                let content = this.emailTemplate.content
                
                let movimentacoesAsArray = this.fileListRetornoMovimentacoes[0].fileData
                let movimentacoesHeader = movimentacoesAsArray[0]
                let movimentacoesFromDistributor = movimentacoesAsArray.filter((line) => line[31] == distributor["CNPJDistribuidor"])
                let attachmentContent = [movimentacoesHeader, ...movimentacoesFromDistributor].map((line) => {
                    return line.join('\t')
                }).join('\n')

                let sendDistributorsEmail = firebase.functions().httpsCallable('sendDistributorsEmail')
                let result = await sendDistributorsEmail({recipients, subject, content, attachmentContent})
            }))
        }
    },
    computed: {
        tableDistribuidor() {
            return this.distribuidorTable
        }
    },
    async created() {
        this.loading = true
        
        db.collection('xmlNewClientTemplate')
            .onSnapshot(
                q => {
                    let auxTable = []
                    q.forEach(doc => {
                        auxTable.push({
                            id: doc.id,
                            CNPJDistribuidor: maybeRemoveFirstZero(doc.data().CNPJDistribuidor),
                            nome: doc.data().nome,
                            idPessoaDistribuidor: doc.data().idPessoaDistribuidor,
                            email: doc.data().email,
                            distribuidorCheckbox: {
                                disabled: true,
                                status: false
                            }
                        })
                    })
                    this.distribuidorTable = auxTable
            })

        db.collection('emailDistributorsTemplate')
            .onSnapshot(
                q => {
                    q.forEach(doc => {
                        this.emailTemplate = {
                            recipients: doc.data().recipients,
                            content: doc.data().content,
                            firebaseDocId: doc.id
                        }
                    })
                }
            )
                
        this.updateReturnMovFilesFromDb()
    
        this.loading = false
    },
}
</script>

<style scoped>
.table-manual {
    position: relative;
    margin-top: 10px;
}
.el-input .el-input__inner {
    color: red;
}
.big-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.adicionar-linha {
    float: right;
    margin-bottom: 10px;
}
.download-button {
    margin-left: 30px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.manual {
    width: 400px;
}
.retorno {
    width: 600px;
}
.distributor {
    width: 1500px;
}
.el-dialog .main-title {
    font-weight: bold;
    font-size: 22px;
}
.el-dialog .title-detail {
    font-style: italic;
    font-size: 18px;
}
.manual-content {
    max-width: 400px;
}
.retorno-content {
    max-width: 600px;
}
.distributor-content {
    max-width: 800px;
}
.header-title {
    margin:0;
    font-weight:bold;
    font-size:14px;
    text-decoration:underline;
    color: #606266;
    height: 23px;
}
.date-picker >>> input{
    color: red;
}
.el-header.header {
    width: 1485px;
    font-family: Calibri;
    color: #606266;
    padding: 0 10px;
    font-size: 20px;
    margin-bottom: 5px;
}
.header-manual {
    font-family: Calibri;
    color: #606266;
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
}
.save-table {
    float: right;
    width: 160px;
}
.header-details {
    text-align: center;
}
.el-table .cell {
    word-wrap: break-word;
}
.el-table .cell-size {
    padding: 1px 0;
    font-family: Calibri;
}
.el-main.main {
    padding: 0 10px;
}
.el-footer {
    margin-top: 20px;
    padding: 0;
}
hr { 
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-style: inset;
    border-width: 1px;
}
.detail-date {
    font-style: italic;
    font-size: 15px;
    float: right;
}
.distributor-content-column-2-item {
    margin-bottom: 7px;
}
#table-distribuidors {
    position: relative;
    margin-top: 10px;
    margin-right: 20px;
}
#distributor-content {
    content: "";
    display: table;
    clear: both;
}
#distributor-content-column-1 {
    width: 60%; 
    float: left;
}
#distributor-content-column-2 {
    width: 40%; 
    float: right;
    margin-bottom: 7px;
}
#upload-movimentacao-administradora-mensagem {
    font-size: 17px;
}
</style>